import { useEffect, useRef } from "react";
import type { EventName, EventPayload } from "../../core";
import { useRuntime } from "../runtime/RuntimeContext";

// Subscribe to an inbound event for the component's lifetime. The handler is held
// in a ref so the subscription stays stable across renders (no churn on the bus).
export function useEvent<K extends EventName>(name: K, handler: (payload: EventPayload<K>) => void): void {
    const runtime = useRuntime();
    const handlerRef = useRef(handler);
    handlerRef.current = handler;

    useEffect(() => {
        return runtime.eventBus.on(name, (payload) => handlerRef.current(payload));
    }, [runtime, name]);
}
